/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ isNew: NonNullable<unknown> }} Moving_Next_Racoon_NailInputs */

const fr_moving_next_racoon_nail = /** @type {(inputs: Moving_Next_Racoon_NailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.isNew} une séance`)
};

/**

* @param {Moving_Next_Racoon_NailInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const moving_next_racoon_nail = /** @type {((inputs: Moving_Next_Racoon_NailInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moving_Next_Racoon_NailInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_moving_next_racoon_nail(inputs)
});